module.exports = __webpack_public_path__ + "static/media/mogo.23c848d8.jpg";